import { LightningElement, track, api, createElement  } from 'lwc';

import { showPopover } from '../../../utils/popoverUtils.js';

import { onCloseKeysDispatchBlur } from '../../../utils/basicUtils.js';



export default class sldsRichTextEditor extends LightningElement {
    static renderMode = 'light'; 
    savedRange; // This will hold the saved selection.
    @track inputValue = '';

    popoverElement;

    @api 
    set richTextValue(value) {
        this._richTextValue = value;
    }
    get richTextValue() {
        return this._richTextValue;
    }


    // Focus the the slds-rich-text-editor
    @api 
    focusMe() {
        setTimeout(() => {
            const richTextEditor = this.querySelector('.slds-rich-text-editor');
            if (richTextEditor) richTextEditor.classList.add('slds-has-focus');
            
            const other = this.querySelector('.slds-rich-text-area__content')
            if (other) other.focus();
        }, 50); 
    }

    // Dispatch Blur on escape/enter
    handleKeydown(event) {
        /* Get the contents from the rich text editor
        const editor = this.querySelector('.slds-rich-text-area__content');
        const htmlContent = editor.innerHTML;
        */
        onCloseKeysDispatchBlur.call(this, event, this.inputValue, 'richtext');
    }

    // Call the popover component to render
    renderPopoverStatic(event) {
        // Save the current selection.
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            this.savedRange = selection.getRangeAt(0);
        }

        const publicProperties = {
            inputLabel: 'Enter Link',
            footer: { buttonLabelOk: 'Ok', color: 'medium'},
            nubin: 'top-left',
        };

        const eventListeners = {
            popovercancel: this.handlePopoverMessage.bind(this), 
            popoverok: this.handlePopoverMessage.bind(this)
        };

        this.popoverElement = showPopover(
            event.currentTarget,
            publicProperties,
            eventListeners,
            this.popoverElement
        );
    }

    // Get the link from the popover
    handlePopoverMessage(event) {
        console.log('here is event: ', event);
        // Handle OK or Cancel events from the popover.
        // For example, remove the popover from the DOM.

        if (event.type === 'popoverok' && event.detail) {
            console.log('here is event detail: ',  event.detail);
            // Restore the selection if saved.
            if (this.savedRange) {
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(this.savedRange);
            }

            // Get the URL detail and ensure it has a protocol.
            let url = event.detail;
            if (!/^https?:\/\//i.test(url)) {
                url = 'https://' + url;
            }
            
            // Now execute the command to insert the link.
            document.execCommand('createLink', false, url);
        }
        

        if (this.popoverElement && this.popoverElement.parentNode) {
            document.body.removeChild(this.popoverElement);
        }
        this.popoverElement = null;
        this.savedRange = null;

    }

    // Insert new html as the user switched formatting
    execFormatting(event) {
        // Get the button's value
        const commandValue = event.currentTarget.value;
        
        // Map your custom values to the actual execCommand commands.
        // For example, 'strike-through' should map to 'strikeThrough'
        // and 'bulleted-list' maps to 'insertUnorderedList'.
        const commandMap = {
            "bold": "bold",
            "italic": "italic",
            "underline": "underline",
            "strike-through": "strikeThrough",
            "bulleted-list": "insertUnorderedList",
            "numbered-list": "insertOrderedList",
            "indent": "indent",
            "outdent": "outdent"
        };
    
        const command = commandMap[commandValue];
        
        if (command) {
            // Execute the formatting command on the current selection.
            document.execCommand(command, false, null);
        } else {
            console.warn(`No command found for: ${commandValue}`);
        }
    }

}